import { Pipe, PipeTransform } from '@angular/core';

/**
 * Transforme un tableau de type de donnée en type de filtre
 */
@Pipe({
  name: 'crtTypeFilterValuesPipe',
  standalone: true,
})
export class CrtTypeFilterValuesPipe implements PipeTransform {
  transform(values: string[], nbValuesMax: number): string {
    if (!values) {
      return '';
    }
    if (values.length === nbValuesMax) {
      return $localize`Tous`;
    }
    return values.join(', ');
  }
}
